import {
	createApi,
	fetchBaseQuery,
	BaseQueryFn,
	FetchArgs,
	FetchBaseQueryError
} from "@reduxjs/toolkit/query/react";
import LocalStorage from "../../util/storage";
import { logout } from "../features/authentication/slice";
import { config } from "../../config";

const baseQuery = fetchBaseQuery({
	baseUrl: config.apiUrl,
	prepareHeaders: (headers) => {
		const authData = LocalStorage.get("authData");
		if (authData?.token) {
			headers.set("Authorization", `Bearer ${authData.token}`);
		}
		return headers;
	}
});

const baseQueryWithReauth: BaseQueryFn<
	string | FetchArgs,
	unknown,
	FetchBaseQueryError
> = async (args, queryApi, extraOptions) => {
	let result = await baseQuery(args, queryApi, extraOptions);

	if (result.error && result.error.status === 401) {
		const authData = LocalStorage.get("authData");
		if (authData?.refreshToken) {
			const refreshResult = await baseQuery(
				{
					url: "/auth/refresh",
					method: "POST",
					body: { refreshToken: authData.refreshToken }
				},
				queryApi,
				extraOptions
			);

			if (refreshResult.data) {
				LocalStorage.set("authData", refreshResult.data);
				result = await baseQuery(args, queryApi, extraOptions);
			} else {
				LocalStorage.remove("authData");
				queryApi.dispatch(logout());
			}
		} else {
			LocalStorage.remove("authData");
			queryApi.dispatch(logout());
		}
	}

	return result;
};

export const api = createApi({
	reducerPath: "api",
	baseQuery: baseQueryWithReauth,
	tagTypes: ["User", "McpServer", "SidekickApp", "SidekickBuild", "AppleAccount", "GooglePlayConfig", "MyAiTools", "SavedPrompts", "Skills", "CustomTool", "SlackStatus", "WrikeStatus", "AtlassianStatus", "ActivityLog", "IpRequest", "ScheduledPrompt", "ScheduledJob"],
	endpoints: () => ({})
});
